import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS, INFO_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  checkbox: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    marginTop: 'auto',
    marginBottom: 'auto',
    cursor: 'pointer'
  },
  checkboxLabel: {
    position: 'static',
    cursor: 'pointer'
  },
  card: {
    boxShadow: 'none',
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: 12,
    height: '100%'
  },
  cardContent: {
    padding: 16,
    '&:last-child': {
      paddingBottom: 16
    },
    [theme.breakpoints.down('md')]: {
      padding: '16px 20px !important'
    }
  },
  cardCheckbox: {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  },
  contractNumber: {
    fontSize: 14,
    fontWeight: 600,
    color: INFO_COLORS[600]
  },
  contractInfo: {
    fontSize: 12,
    fontWeight: 500
  }
}))
